@if (calculatorCta() || consultationCta()) {
  <mobi-content-section
    width="lg"
    [content]="howToProceedCards"
    [background]="true"
    clas="no-heading-spacing"
  >
    <ng-template #howToProceedCards>
      <div class="product-further-links mobi-ui-grid is-centered">
        <div class="mobi-ui-col-1/1 lg:mobi-ui-col-3/4 mobi-ui-text-center">
          <h2 class="">
            {{
              'how_to_continue'
                | texts
                  : {
                      context: 'frontend',
                      default: 'Wie möchten Sie weiterfahren?',
                    }
            }}
          </h2>
        </div>
        <div class="mobi-ui-col-1/1">
          <div class="mobi-ui-grid is-centered">
            @if (consultationCta() && consultationCta() | extractUrl) {
              <div
                class="self-stretch product-consultation mobi-ui-col-1/1 sm:mobi-ui-col-1/2"
              >
                <mobi-teaser
                  teaserStyle="icon-stacked"
                  [teaserTitle]="consultationCtaDescription() || consultationCta()!.title"
                  [teaserTextShort]="consultationCtaTitle()"
                  [teaserUrl]="consultationCta() | extractUrl"
                  [teaserTarget]="consultationCta()!.options?.attributes?.target"
                  [teaserIllustration]="{ name: '', symbol: 'signpost' }"
                  [inked]="true"
                ></mobi-teaser>
              </div>
            }
            @if (calculatorCta() && calculatorCta() | extractUrl) {
              <div
                class="self-stretch product-calculator mobi-ui-col-1/1 sm:mobi-ui-col-1/2 mobi-ui-ink-green"
                [class.cursor-pointer]="hasPrerollout()"
                (click)="hasPrerollout() && onCalculatorCtaClick($event)"
              >
                <mobi-teaser
                  teaserStyle="icon-stacked"
                  [teaserTitle]="calculatorCtaDescription() || calculatorCta()!.title"
                  [teaserTextShort]="calculatorCtaTitle()"
                  [teaserUrl]="calculatorCta() | extractUrl"
                  [teaserTarget]="calculatorCta()!.options?.attributes?.target"
                  [teaserIllustration]="{ name: '', symbol: 'calculator' }"
                  [inked]="true"
                  [class.pointer-events-none]="hasPrerollout()"
                ></mobi-teaser>
              </div>
            }
          </div>
        </div>
      </div>
    </ng-template>
  </mobi-content-section>
}

@if (hasPrerollout()) {
  <mobi-prerollout-overlay
    #prerolloutOverlay
    [nodeId]="nodeId()!"
    [prerolloutUrl]="calculatorCtaPrer()?.uri?.path || ''"
    [regularUrl]="calculatorCta() | extractUrl"
    [ctaTarget]="calculatorCta()?.options?.attributes?.target"
    trackingContext="link"
    [trackingName]="calculatorCta()?.title || ''"
  />
}
